import React, { useEffect, useState } from 'react'
import {
  CButton,
  CCard,
  CCardBody,
  CCol,
  CImage,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
  CAlert,
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilCart, cilArrowCircleLeft } from '@coreui/icons'
import apiClient from '../../services/apiClient'
import { useNavigate } from 'react-router-dom'
import { buildApiUrl } from '../../utils/getConfiguration'

const Cafeteria = () => {
  const [accounts, setAccounts] = useState([])

  const fetchAccountsData = async () => {
    try {
      // Example: buildApiUrl('account', { email: localStorage.getItem('mail') })
      const mail = localStorage.getItem('mail')
      const response = await apiClient.get(buildApiUrl('account', { email: mail }))
      setAccounts(response.data)
    } catch (error) {
      console.error('Error fetching recommendations', error)
    }
  }

  useEffect(() => {
    fetchAccountsData()
  }, [])

  const [items, setItems] = useState([])

  const fetchItemsData = async () => {
    try {
      // Example: buildApiUrl('cafeteria', { account_ID: localStorage.getItem('account_ID') })
      const account_ID = localStorage.getItem('account_ID')
      const response = await apiClient.get(buildApiUrl('cafeteria', { account_ID }))
      setItems(response.data)
    } catch (error) {
      console.error('Error fetching cafeteria items', error)
    }
  }

  useEffect(() => {
    fetchItemsData()
  }, [])

  const [visible, setVisible] = useState(false)

  let navigate = useNavigate()
  return (
    <>
      <CCard className="mb-4">
        <CCardBody>
          <CCol sm={12}>
            <h4 id="traffic" className="card-title mb-0">
              Cafeteria - select your reward...
            </h4>
            <hr></hr>
          </CCol>
          <CCol sm={12}>
            <CButton
              color="primary"
              onClick={() => {
                //localStorage.removeItem('loginName1')
                //localStorage.removeItem('wizard')
                console.log('Back')
                navigate('/dashboard')
              }}
            >
              <CIcon icon={cilArrowCircleLeft} size="xxl" />
            </CButton>
          </CCol>
          <CCol>
            <hr></hr>
            <CTable align="middle" className="mb-0 border" hover responsive>
              <CTableHead color="light">
                <CTableRow>
                  <CTableHeaderCell className="text-left">Item</CTableHeaderCell>
                  <CTableHeaderCell className="text-center">Description</CTableHeaderCell>
                  <CTableHeaderCell className="text-center">Membership validity</CTableHeaderCell>
                  <CTableHeaderCell className="text-center">Category</CTableHeaderCell>
                  <CTableHeaderCell className="text-center">Price (points)</CTableHeaderCell>
                  <CTableHeaderCell className="text-center">Action</CTableHeaderCell>
                </CTableRow>
              </CTableHead>
              <CTableBody>
                {items.map((item) => (
                  <CTableRow v-for="item in tableItems" key={item.item_id}>
                    <CTableDataCell color="secondary">
                      <CImage
                        rounded
                        orientation="top"
                        src={item.pic}
                        width={50}
                        height={50}
                        onClick={() => {
                          //console.log('Task Detail ' + recommendation.reminder_ID)
                          //localStorage.setItem('taskid', recommendation.reminder_ID)
                          //localStorage.setItem('grp_ID', '1')
                        }}
                      />
                    </CTableDataCell>
                    {String(item.membership_name) === String(localStorage.getItem('membership')) ? (
                      <CTableDataCell className="text-center" color="secondary">
                        <div>{item.name}</div>
                        <div className="small text-medium-emphasis">
                          <span>{item.description}</span>
                        </div>
                      </CTableDataCell>
                    ) : (
                      <CTableDataCell className="text-center" color="white" disabled>
                        <div>{item.name}</div>
                        <div className="small text-medium-emphasis">
                          <span>{item.description}</span>
                        </div>
                      </CTableDataCell>
                    )}
                    {String(item.membership_name) === String(localStorage.getItem('membership')) ? (
                      <CTableDataCell className="text-center" color="success">
                        <div className="small text-medium-emphasis">{item.membership_name}</div>
                      </CTableDataCell>
                    ) : (
                      <CTableDataCell className="text-center" color="danger" disabled>
                        <div className="small text-medium-emphasis">{item.membership_name}</div>
                      </CTableDataCell>
                    )}
                    {String(item.membership_name) === String(localStorage.getItem('membership')) ? (
                      <CTableDataCell className="text-center" color="secondary">
                        <div className="small text-medium-emphasis">{item.category}</div>
                      </CTableDataCell>
                    ) : (
                      <CTableDataCell className="text-center" color="white">
                        <div className="small text-medium-emphasis">{item.category}</div>
                      </CTableDataCell>
                    )}
                    <CTableDataCell className="text-center" color="secondary">
                      <div className="small text-medium-emphasis">{item.price}</div>
                    </CTableDataCell>
                    <CTableDataCell className="text-center" color="secondary">
                      <CButton
                        color="primary"
                        disabled
                        onClick={() => {
                          //navigate('/login')
                        }}
                      >
                        <CIcon icon={cilCart} className="me-2" />
                      </CButton>
                    </CTableDataCell>
                  </CTableRow>
                ))}
              </CTableBody>
            </CTable>
            <hr></hr>
            <CAlert color="primary" dismissible visible={visible} onClose={() => setVisible(false)}>
              Do you want to select higher membership? .
              {String(localStorage.getItem('membership')) !== String('PRO') && (
                <CButton
                  color="primary"
                  onClick={() => {
                    console.log('Set PRO membership')
                    localStorage.setItem('newmembership', 'PRO')
                    localStorage.setItem('newprice', '19.99')
                    navigate('/payments')
                  }}
                  //href="mailto:galia@gaspena.eu?subject=Order PRO membership&body=Dear team, I am ordering Reminder PRO membership. Please send me an invoice to my email. Thank you."
                >
                  PRO
                </CButton>
              )}
              .
              <CButton
                color="primary"
                onClick={() => {
                  console.log('Set ELITE membership')
                  localStorage.setItem('newmembership', 'ELITE')
                  localStorage.setItem('newprice', '49.99')
                  navigate('/payments')
                }}
                //href="mailto:galia@gaspena.eu?subject=Order ELITE membership&body=Dear team, I am ordering Reminder ELITE membership. Please send me an invoice to my email. Thank you."
              >
                ELITE
              </CButton>
            </CAlert>
            <div className="small text-medium-emphasis">
              {accounts.length > 0 && (
                <div>
                  {accounts.map((account) => (
                    <div key={account.id}>
                      <div>
                        <h5 id="traffic" className="card-title mb-0">
                          ORDERED ITEMS:
                        </h5>
                        <p>n/a</p>
                        <hr />
                        <h5 id="traffic" className="card-title mb-0">
                          Remaining coins: {localStorage.getItem('score')}
                        </h5>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </CCol>
        </CCardBody>
      </CCard>
      <CCard
      // key={recommendation.reminder_ID}
      // style={{ width: '12rem', height: '25rem' }}
      >
        <CCardBody>
          <CCol sm={12}>
            <CButton
              color="primary"
              onClick={() => {
                //localStorage.removeItem('loginName1')
                //localStorage.removeItem('wizard')
                console.log('Back')
                navigate('/dashboard')
              }}
            >
              <CIcon icon={cilArrowCircleLeft} size="xxl" />
            </CButton>
          </CCol>
        </CCardBody>
      </CCard>
    </>
  )
}

export default Cafeteria
